/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 14:18:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 16:55:21
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/EditorCollapsePageLayout/SectionHocWithData/index.tsx
 */
import React, { useState, ReactNode } from 'react';
//import css from './css.module.less';

//import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
//import { store } from 'src/store';
import { SectionCollapse } from '@/src/components/Antd';
import SectionTitle from 'src/layout/EditorPageLayout/SectionTitle';
import { Modal } from 'src/components/Antd';

const SectionHOC = (Component: any, obj) => {
  const {
    getCollapse,
    title,
    onCollapseChange,
    collapseProps,
    useCustomCollapseTitle,
    getContent,
    getLoaded,

    titleGenerator,
    customPropsGenerator,
    openMargin,
  } = obj;

  const WrappedComponent = (props) => {
    const { uuid } = props;

    const _d = useDispatch();
    const data: any = useSelector(getContent(uuid)) || {};

    const loaded = useSelector(getLoaded());
    const _uuid = uuid || data.uuid;
    const customProps = customPropsGenerator
      ? customPropsGenerator({ data, uuid: _uuid })
      : {};
    //const { allNodesWithOrder, dataSet } = useSelector(getMoveList(uuid));

    //useSelector(getMoveList(_uuid)) || [];
    const _open = useSelector(getCollapse(_uuid));

    const handleOnCollapseChange = (status) => {
      _d(onCollapseChange({ id: _uuid, status }));
    };
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
    const onModalCancel = () => {
      setShowModal(false);
    };
    const [modalContent, setModalContent] = useState<ReactNode>('');
    const _props = {
      setShowModal,
      setModalTitle,
      setModalContent,
      onModalCancel,
      data,
      uuid: _uuid,
      ...customProps,
      ...props,
    };

    const _title = React.useMemo(() => {
      if (useCustomCollapseTitle) {
        if (!title && titleGenerator) {
          return titleGenerator(data);
        } else if (title && !titleGenerator) {
          return title;
        } else {
          return <React.Fragment />;
        }
      } else {
        return <SectionTitle title={title} />;
      }
    }, [titleGenerator, useCustomCollapseTitle, title, data]);

    const _r = React.useMemo(() => {
      return loaded && _uuid ? (
        <SectionCollapse
          open={_open}
          key={_uuid}
          id={_uuid}
          //titleStyle={i.style}
          title={_title}
          content={<Component {..._props} />}
          openMargin={openMargin || 16}
          onClickTrigger={handleOnCollapseChange}
          {...(collapseProps || {})}
        />
      ) : null;
    }, [_open, props, collapseProps, title, loaded]);

    return (
      <React.Fragment>
        <Modal
          width={600}
          visible={showModal}
          title={modalTitle}
          onCancel={onModalCancel}
          cancelText={'Cancel'}>
          {modalContent}
        </Modal>
        {_r}
      </React.Fragment>
    );
  };
  return WrappedComponent;
};
export default SectionHOC;
